(function () {
  "use strict";

  function activateTab(btn) {
    const widget = btn.closest(".mega-menu-tabs-widget");
    if (!widget) return;

    const targetSelector = btn.getAttribute("data-tab-target");
    if (!targetSelector) return;

    const targetPane = widget.querySelector(targetSelector);
    if (!targetPane) return;

    const tabBtns = widget.querySelectorAll(".mega-menu-tab-btn");
    const tabPanes = widget.querySelectorAll(".mega-menu-tab-pane");

    tabBtns.forEach((b) => {
      b.classList.remove("active");
      b.setAttribute("aria-selected", "false");
    });

    tabPanes.forEach((p) => {
      p.classList.remove("active", "show");
    });

    btn.classList.add("active");
    btn.setAttribute("aria-selected", "true");

    targetPane.classList.add("active");
    // Force layout reflow before triggering smooth opacity transition
    void targetPane.offsetWidth;
    targetPane.classList.add("show");
  }

  // Delegated event listener for hover trigger
  document.addEventListener("mouseover", function (e) {
    const btn = e.target.closest(".mega-menu-tabs-widget .mega-menu-tab-btn");
    if (!btn) return;

    const widget = btn.closest(".mega-menu-tabs-widget");
    const trigger = widget ? widget.getAttribute("data-trigger") : "hover";

    if (trigger === "hover" && !btn.classList.contains("active")) {
      activateTab(btn);
    }
  });

  // Delegated event listener for click trigger & link control
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".mega-menu-tabs-widget .mega-menu-tab-btn");
    if (!btn) return;

    const widget = btn.closest(".mega-menu-tabs-widget");
    const trigger = widget ? widget.getAttribute("data-trigger") : "hover";

    const href = btn.getAttribute("href");
    const isDummyLink = !href || href === "#" || href.indexOf("javascript:") === 0;

    if (isDummyLink || trigger === "click" || !btn.classList.contains("active")) {
      e.preventDefault();
      activateTab(btn);
    }
  });

  // Support Elementor Editor dynamic re-renders
  if (window.jQuery) {
    window.jQuery(window).on("elementor/frontend/init", function () {
      if (window.elementorFrontend && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction(
          "frontend/element_ready/mega-menu-tabs.default",
          function ($scope) {
            const activeBtn = $scope[0].querySelector(".mega-menu-tab-btn.active");
            if (activeBtn) {
              activateTab(activeBtn);
            }
          }
        );
      }
    });
  }
})();
